<script setup lang="ts">
/**
 * Marque APY pour le shell V2 (sidebar desktop, sidebar mobile, header mobile).
 *
 * Choix : on utilise la **tuile** (`apy-mark`, pastille #033F52 + APY + sourire)
 * dans tous les contextes — même repère que le favicon / l'icône PWA, donc
 * cohérence visuelle maximale. La tuile étant carrée, elle marche dépliée comme
 * repliée sans picto distinct.
 *
 * - `collapsed` → tuile seule, centrée.
 * - sinon → tuile + baseline contextuelle (défaut « Intranet »).
 *
 * La baseline « Intranet » est en corail fixe (identité produit) ; la couleur
 * de la section active, elle, est portée par le badge du header (cf ApyLayout)
 * et par `--hub-accent`.
 */
import ApyMark from '@/v2/assets/brand/apy-mark.svg'

withDefaults(
  defineProps<{
    collapsed?: boolean
    /** Taille Tailwind de la tuile (carrée) — ex. 'h-10 w-10' */
    markClass?: string
    /** Baseline affichée à droite de la tuile (ignorée si vide ou si collapsed) */
    baseline?: string
  }>(),
  { collapsed: false, markClass: 'h-10 w-10', baseline: 'Intranet' },
)
</script>

<template>
  <ApyMark v-if="collapsed" :class="[markClass, 'shrink-0']" aria-hidden="true" />

  <div v-else class="flex min-w-0 items-center gap-2">
    <ApyMark :class="[markClass, 'shrink-0']" aria-hidden="true" />
    <template v-if="baseline">
      <span class="h-5 w-px shrink-0 bg-base-300" aria-hidden="true" />
      <span
        class="truncate text-sm font-semibold leading-none"
        :style="{ color: 'var(--apy-s2)' }"
      >
        {{ baseline }}
      </span>
    </template>
  </div>
</template>
